import Cookies from 'js-cookie';
import { Component } from 'react';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

const CountrySwitcher = observer(
  class CountrySwitcher extends Component {
    countryPreference = 'us';
    hasMounted = false;

    componentDidMount = () => {
      const cookie = Cookies.get('countrypreference');
      if (cookie) this.countryPreference = cookie.toLowerCase();
      this.hasMounted = true;
    };

    flagIconUrl = () =>
      this.countryPreference == 'uk'
        ? this.props.ukFlagIconUrl
        : this.props.usFlagIconUrl;

    handleSwitcherChange = (event) => {
      this.countryPreference = event.target.value;
      Cookies.set('countrypreference', this.countryPreference.toUpperCase(), {
        expires: 365,
      });
      if (this.props.mirrorUrl) window.location = this.props.mirrorUrl;
    };

    constructor(props) {
      super(props);

      makeObservable(this, {
        countryPreference: observable,
        hasMounted: observable,
      });
    }

    render() {
      return (
        <div className='input-wrapper country-f mb-0 theme-maji'>
          {this.hasMounted && (
            <div>
              <span
                className='bg-center bg-no-repeat bg-contain preinput ml-1 w-4 h-4'
                style={{ backgroundImage: `url(${this.flagIconUrl()})` }}
              />
              <select
                autoComplete='off'
                className='country-footer pl-3'
                name='country'
                onChange={this.handleSwitcherChange}
                value={this.countryPreference}
              >
                <option value='us'>{this.props.usCurrencyFullName}</option>
                <option value='uk'>{this.props.ukCurrencyFullName}</option>
              </select>
            </div>
          )}
        </div>
      );
    }
  }
);

export default CountrySwitcher;
